import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import store from './store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: { auth: true },
      children: [
        {
          path: '/about',
          name: 'about',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
          path: '/',
          name: 'home',
          component: Home
        },
        {
          path: '/forbidden',
          name: 'forbidden',
          component: () => import('./views/Forbidden.vue')
        },
        {
          path: '/datasets',
          name: 'datasetList',
          component: () => import('./views/DatasetList.vue'),
          meta: {
            auth: {
              roles: ['dataset:read', 'dataset:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/datasets/add',
          name: 'datasetAddForm',
          component: () => import('./views/DatasetItem.vue'),
          meta: {
            auth: {
              roles: ['dataset:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/datasets/:id/edit',
          name: 'datasetEditForm',
          component: () => import('./views/DatasetItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['dataset:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/topic-models',
          name: 'topicModelList',
          component: () => import('./views/TopicModelList.vue'),
          meta: {
            auth: {
              roles: ['topic:read', 'topic:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/topic-models/:id/edit',
          name: 'topicModelEdit',
          component: () => import('./views/TopicModelItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['topic:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/topic-models/:id/statistics',
          name: 'topicModelStatistics',
          component: () => import('./views/TopicModelStatisticsItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['topic:read', 'topic:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/topic-models/add',
          name: 'topicModelAdd',
          component: () => import('./views/TopicModelItem.vue'),
          meta: {
            auth: {
              roles: ['topic:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/topic-models/:topicModel/topics/:topicId/edit',
          name: 'topicEdit',
          component: () => import('./views/TopicItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['topic:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/topic-models/:topicModel/topics/add',
          name: 'topicAdd',
          component: () => import('./views/TopicItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['topic:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/sentiment-models',
          name: 'sentimentModelList',
          component: () => import('./views/SentimentModelList.vue'),
          meta: {
            auth: {
              roles: ['sentiment:read', 'sentiment:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/sentiment-models/add',
          name: 'sentimentModelAdd',
          component: () => import('./views/SentimentModelItem.vue'),
          meta: {
            auth: {
              roles: ['sentiment:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/sentiment-models/:id/edit',
          name: 'sentimentModelEdit',
          component: () => import('./views/SentimentModelItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['sentiment:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/sentiment-models/:id/try',
          name: 'sentimentModelTry',
          component: () => import('./views/SentimentModelTry.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['sentiment:read', 'sentiment:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/sentiment-models/:id/statistics',
          name: 'sentimentModelStatistics',
          component: () => import('./views/SentimentModelStatisticsItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['sentiment:read', 'sentiment:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/sentiment-models/:id/export',
          name: 'sentimentModelExport',
          component: () => import('./views/SentimentModelExport.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['sentiment:read', 'sentiment:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/topic-models/:id/try',
          name: 'topicModelTry',
          component: () => import('./views/TopicModelTry.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['topic:read', 'topic:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/topic-models/:id/export',
          name: 'topicModelExport',
          component: () => import('./views/TopicModelExport.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['topic:read', 'topic:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/scheduled-jobs',
          name: 'scheduledJobList',
          component: () => import('./views/ScheduledJobList.vue'),
          meta: {
            auth: {
              roles: ['job:read', 'job:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/scheduled-jobs/:id/logs',
          name: 'scheduledJobLogs',
          component: () => import('./views/ScheduledJobItemLogs.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['job:read', 'job:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/scheduled-jobs/:id/logs/:logId/experiment-logs',
          name: 'scheduledJobExperimentLogs',
          component: () => import('./views/ScheduledJobExperimentLog.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['job:read', 'job:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/scheduled-jobs/:id/logs/:logId/scoring-logs',
          name: 'scheduledJobScoringLogs',
          component: () => import('./views/ScheduledJobScoringLog.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['job:read', 'job:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/scheduled-jobs/:id/edit',
          name: 'scheduledJobEdit',
          component: () => import('./views/ScheduledJobItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['job:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/scheduled-jobs/add',
          name: 'scheduledJobAdd',
          component: () => import('./views/ScheduledJobItem.vue'),
          meta: {
            auth: {
              roles: ['job:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/users',
          name: 'userList',
          component: () => import('./views/UserList.vue'),
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/users/:id/edit',
          name: 'userEdit',
          component: () => import('./views/UserItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/users/add',
          name: 'userAdd',
          component: () => import('./views/UserItem.vue'),
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/roles',
          name: 'roleList',
          component: () => import('./views/RoleList.vue'),
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/roles/:id/edit',
          name: 'roleEdit',
          component: () => import('./views/RoleItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/roles/add',
          name: 'roleAdd',
          component: () => import('./views/RoleItem.vue'),
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/annotation-works',
          name: 'annotationWorkList',
          component: () => import('./views/AnnotationWorkList.vue'),
          meta: {
            auth: {
              roles: ['annotation:read', 'annotation:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/annotation-works/:id/edit',
          name: 'annotationWorkEdit',
          component: () => import('./views/AnnotationWorkItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['annotation:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/annotation-works/add',
          name: 'annotationWorkAdd',
          component: () => import('./views/AnnotationWorkItem.vue'),
          meta: {
            auth: {
              roles: ['annotation:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/annotators',
          name: 'annotatorList',
          component: () => import('./views/AnnotatorList.vue'),
          meta: {
            auth: {
              roles: ['annotation:read', 'annotation:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/annotators/:id/edit',
          name: 'annotatorEdit',
          component: () => import('./views/AnnotatorItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['annotation:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/annotators/add',
          name: 'annotatorAdd',
          component: () => import('./views/AnnotatorItem.vue'),
          meta: {
            auth: {
              roles: ['annotation:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/annotation-works/:annotationWorkId/annotation-tasks/add',
          name: 'annotationTaskAdd',
          component: () => import('./views/AnnotationTaskItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['annotation:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/annotation-works/:annotationWorkId/annotation-tasks/upload',
          name: 'annotationTaskUpload',
          component: () => import('./views/AnnotationTaskUpload.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['annotation:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/annotation-works/:annotationWorkId/annotation-tasks/:id/edit',
          name: 'annotationTaskEdit',
          component: () => import('./views/AnnotationTaskItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['annotation:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/annotation-works/:annotationWorkId/statistics',
          name: 'annotationWorkStatistics',
          component: () => import('./views/AnnotationWorkStatisticsItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['annotation:read', 'annotation:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/system-configurations',
          name: 'systemConfigurationList',
          component: () => import('./views/SystemConfigurationList.vue'),
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/version',
          name: 'systemVersionList',
          component: () => import('./views/SystemVersionList.vue'),
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/system-configurations/:id/edit',
          name: 'systemConfigurationEdit',
          component: () => import('./views/SystemConfigurationItem.vue'),
          props: true,
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/logs',
          name: 'logList',
          component: () => import('./views/LogList.vue'),
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        },
        {
          path: '/health',
          name: 'healthInfo',
          component: () => import('./views/Health.vue'),
          meta: {
            auth: {
              roles: ['system:manage'],
              forbiddenRedirect: { name: 'forbidden' }
            }
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { auth: false }
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('loader/setLoader', {
    loading: false
  })
  next()
})

export default router
